import { useEffect, useState } from 'react';
import { fetchPlayerStats } from '../../services/api';
import { Bar, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import './Dashboard.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend);

function Dashboard({ player, onBack }) {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPlayerStats(player.id)
      .then(setStats)
      .catch((err) => setError(err.message));
  }, [player.id]);

  if (error) return <p>Fehler: {error}</p>;
  if (!stats) return <p>Lade Dashboard...</p>;

  const barData = {
    labels: stats.sessions.map((s, i) => `Runde ${i + 1}: ${s.scenario_title}`),
    datasets: [{
      label: 'Punkte',
      data: stats.sessions.map((s) => s.points_earned),
      backgroundColor: '#4CAF50',
    }],
  };

  const pieData = {
    labels: ['Richtige Klicks', 'Falsche Klicks'],
    datasets: [{
      data: [stats.totalCorrect, stats.totalWrong],
      backgroundColor: ['#4CAF50', '#f44336'],
    }],
  };

  return (
    <div className="dashboard">
      <h2>Dein Lernfortschritt</h2>

      <div className="dashboard-stats">
        <div className="stat-box">
          <p className="stat-label">Gesamtpunkte</p>
          <p className="stat-value">{stats.player.total_points}</p>
        </div>
        <div className="stat-box">
          <p className="stat-label">Level</p>
          <p className="stat-value">{stats.player.current_level}</p>
        </div>
        <div className="stat-box">
          <p className="stat-label">Gespielte Runden</p>
          <p className="stat-value">{stats.sessions.length}</p>
        </div>
      </div>

      {stats.sessions.length > 0 ? (
        <>
      <div className="chart-container">
        <h3>Punkte pro Runde</h3>
        <div style={{ maxWidth: '500px', margin: '0 auto' }}>
          <Bar data={barData} options={{ responsive: true }} />
        </div>
      </div>
          <div className="chart-container">
  <h3>Richtige vs. Falsche Klicks</h3>
  <div style={{ maxWidth: '300px', margin: '0 auto' }}>
    <Pie data={pieData} options={{ responsive: true }} />
  </div>
</div>
        </>
     ) : (
  <div className="no-data">
    <p>📊 Noch keine Spieldaten vorhanden — spiele zuerst ein Szenario!</p>
  </div>
)}

      <button onClick={onBack}>Zurück zum Spiel</button>
    </div>
  );
}

export default Dashboard;